// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Q78c","delete":"styles_delete__3Lb8J","update":"styles_update__qliAC","add":"styles_add__3SYf7"};